"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeWithFormatter = exports.Time = void 0;
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
const styled_components_1 = require("../styled-components");
const date_fns_1 = require("date-fns");
const locale_1 = require("../locale");
const Time = (props) => {
    const dateString = (0, date_fns_1.format)(props.date, props.format, {
        locale: locale_1.currentLocale,
    });
    return (react_1.default.createElement(TimeElement, { className: props.className, title: props.noTitle ? undefined : props.date.toString(), dateTime: props.date.toString(), color: props.color }, dateString));
};
exports.Time = Time;
/** For performance, when formatting a large number of dates/times on one page, reuse a single native DateTimeFormat rather than calling date-fns every time.
 * We also accept the date as a string, since that's how it's usually stored.
 */
const TimeWithFormatter = ({ date, formatter, }) => {
    return (react_1.default.createElement(TimeElement, { dateTime: date }, formatter.format(new Date(date))));
};
exports.TimeWithFormatter = TimeWithFormatter;
const TimeElement = styled_components_1.styled.time `
  flex: 1 0 auto;
  text-overflow: ellipsis;
  overflow: hidden;
  color: ${({ color, theme }) => color || theme.fg};
`;
//# sourceMappingURL=Time.js.map